import { Controller } from "@hotwired/stimulus"
import IMask from "imask"

// Connects to data-controller="phone-mask"
export default class extends Controller {
  static values = { pattern: String }

  connect() {
    this.mask = IMask(this.element, {
      mask: this.patternValue || '+000000000000000'
    })
  }

  disconnect() {
    if (this.mask) {
      this.mask.destroy()
    }
  }
}
